module.exports = __webpack_public_path__ + "img/home.e11c2d5b.svg";